import React, { useState, useContext } from "react";
import styles from "../../styles/components/UI/InputSelector.module.css";
import { ErrorPopup } from "../error/ErrorPopup";
import { ThemeContext } from "../../context/ThemeContext";

export const InputSelector = ({
  filterName,
  selectedValue,
  handleFilterChange,
  hasError,
  errorMessage,
  isFocused,
  onFocus,
  onBlur,
  type = "text",
  placeholder,
  disabled,
}) => {
  const { theme } = useContext(ThemeContext);
  const [isMouseEnter, setIsMouseEnter] = useState(false);

  const handleMouseEnter = () => {
    setIsMouseEnter(true);
  };

  const handleMouseLeave = () => {
    setIsMouseEnter(false);
  };

  const inputClassName = `
    ${styles.input} 
    ${hasError ? styles.error : ""} 
    ${isFocused ? styles.focused : ""} 
    ${theme === 'dark' ? styles.darkInput : ""}
  `;

  return (
    <div className={styles.inputContainer}>
      <input
        type={type}
        name={filterName}
        value={selectedValue ?? ''}
        onChange={(e) => handleFilterChange(filterName, e.target.value)}
        onFocus={() => onFocus && onFocus(filterName)}
        onBlur={() => onBlur && onBlur(filterName)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        disabled={disabled}
        placeholder={placeholder}
        className={inputClassName}
      />

      {hasError && isMouseEnter && errorMessage && (
        <ErrorPopup message={errorMessage} theme={theme} />
      )}
    </div>
  );
};
